var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-button",
    {
      attrs: {
        icon: "action-download",
        size: _vm.size,
        disabled: _vm.disabled,
        loading: _vm.report.loading,
      },
      on: { click: _vm.sendReportFile },
    },
    [_vm._v(_vm._s(_vm.$t("report.download")))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }